import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const primaryColor = "#1976d2";

/**
 * ✅ Reusable component to render CircuitJS code as a visual diagram
 * @param {string} code - The circuit design code (should start with '$')
 * @param {string} title - Optional title for the diagram
 */
const CircuitViewer = ({ code, title }) => {
  if (!code || typeof code !== "string" || !code.startsWith("$")) return null;

  // Encode the circuit code for the URL
  const encodedCode = encodeURIComponent(code);
  const simulatorUrl = `https://lushprojects.com/circuitjs/circuitjs.html?cct=${encodedCode}`;

  return (
    <Box sx={{ width: "100%", mt: 2, mb: 2 }}>
      <Typography variant="caption" sx={{ fontWeight: "bold", color: primaryColor, mb: 1, display: "block" }}>
        {title || "🎨 Circuit Diagram (Read-Only View)"}
      </Typography>
      <Paper
        elevation={3}
        sx={{
          border: `2px solid ${primaryColor}`,
          borderRadius: "12px",
          width: "100%",
          height: "350px",
          overflow: "hidden",
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        {/* Iframe for rendering */}
        <iframe
          src={simulatorUrl}
          title="CircuitJS Preview"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          loading="lazy"
        />

        {/* Transparent Overlay to make it Read-Only */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 10,
            cursor: "default",
            backgroundColor: "transparent",
          }}
        />
      </Paper>
    </Box>
  );
};

export default CircuitViewer;
